import { ExpenseItem } from "@/api/cost/expenses-api";
import { map, groupBy, sumBy } from "lodash";

/**
 * 小計
 */
export interface ExpenseSubTotal {
  expenseCategoryId: string;
  name: string;
  price: number;
}

/**
 * 経費の項目ごとの小計を計算する
 */
export function itemsSubTotal(items: ExpenseItem[]): ExpenseSubTotal[] {
  return items.flatMap(i => itemSubTotal(i));
}

/**
 * 経費の項目の小計を計算する
 */
export function itemSubTotal(item: ExpenseItem): ExpenseSubTotal[] {
  if (item.items && item.items.length > 0) {
    return itemsSubTotal(item.items).map(b => ({
      ...b,
      price: b.price * item.amount
    }));
  }
  return [
    {
      expenseCategoryId: item.expenseCategoryId,
      name: "",
      price: item.unitPrice * item.amount
    }
  ];
}

/**
 * カテゴリごとに集計する
 */
export function categorySubTotal(items: ExpenseSubTotal[]): ExpenseSubTotal[] {
  return map(
    groupBy(items, "expenseCategoryId"),
    (list, expenseCategoryId) => ({
      expenseCategoryId,
      name: "",
      price: sumBy(list, item => Number(item.price))
    })
  );
}
